module.exports = __webpack_public_path__ + "img/loader_spinner.9c39dc7f.gif";